export default {"src":"/_next/static/media/voucher.3eeef700.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};